import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { environment as ENV } from "environments/environment";
import { NuevoEncargadoDTO } from "../../models/encargado.model";
const API = "clientes";

@Injectable({
    providedIn: "root",
})
export class EncargadoService {

  constructor(private http: HttpClient) {}

    fetchEncargadosSucursal(idSucursal:number): Observable<NuevoEncargadoDTO[]> {   
        return this.http.get<NuevoEncargadoDTO[]>(
            `${ENV.apiUrl}${API}/${idSucursal}/encargados`
        );
    }

    save(idSucursal:number, encargado:NuevoEncargadoDTO){
        return this.http.put<NuevoEncargadoDTO>(`${ENV.apiUrl}${API}/${idSucursal}/encargado`, encargado);
    }

    delete(idSucursal:number, rutEncargado:number){
        return this.http.delete<any>(`${ENV.apiUrl}${API}/${idSucursal}/encargado/${rutEncargado}`);
    }
}
